export type DetectedUiLanguage = "en" | "id";

const INDO_TIMEZONES = new Set(["Asia/Jakarta", "Asia/Makassar", "Asia/Pontianak", "Asia/Jayapura"]);

const MALAYSIA_TIMEZONES = new Set(["Asia/Kuala_Lumpur", "Asia/Kuching"]);

function browserList(languages?: readonly string[]): string[] {
    if (languages?.length) return [...languages];
    if (typeof navigator === "undefined") return [];
    if (navigator.languages?.length) return [...navigator.languages];
    return navigator.language ? [navigator.language] : [];
}

/** First visit only: Indonesia → Bahasa, Malaysia → English. Does not override a stored choice. */
export function detectDefaultUiLanguage(
    timeZone = typeof Intl !== "undefined" ? Intl.DateTimeFormat().resolvedOptions().timeZone : "",
    languages?: readonly string[],
    hostname = typeof location !== "undefined" ? location.hostname : "",
): DetectedUiLanguage {
    if (INDO_TIMEZONES.has(timeZone)) return "id";
    if (MALAYSIA_TIMEZONES.has(timeZone)) return "en";

    for (const raw of browserList(languages)) {
        const tag = raw.toLowerCase();
        if (tag === "id" || tag.startsWith("id-")) return "id";
        if (tag === "ms" || tag.startsWith("ms-") || tag.endsWith("-my")) return "en";
    }

    const host = hostname.toLowerCase();
    if (host.includes(".id.") || host.endsWith(".id")) return "id";
    return "en";
}

export function seedUiLanguage(storageKey: string): void {
    try {
        if (localStorage.getItem(storageKey)) return;
        localStorage.setItem(storageKey, detectDefaultUiLanguage());
    } catch {
        /* private mode / blocked storage */
    }
}
